import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useIntl } from 'react-intl'
import ErrorTemplate from '../../organisms/error-template/error-template'

const InternalServerErrorPageComponent = () => {
	const { internalServerError: { bgImage, bgImageMobile } = {} } = useConfig()
	const { formatMessage } = useIntl()

	return (
		<ErrorTemplate
			bgImage={bgImage}
			bgImageMobile={bgImageMobile}
			message={formatMessage({ id: 'internal_server_error', defaultMessage: 'Internal server error' })}
			title={500}
		/>
	)
}

export default InternalServerErrorPageComponent
